import reducer from './reducers';

export { default as userOperations } from './operations';
export { default as userTypes } from './types';

export default reducer;


// WEBPACK FOOTER //
// ./src/redux/user/index.js